export function jfSeparator () {
  return {
    template: '<div style="border-bottom: 1px solid #e9e9e9; height: 2px; margin: 30px 0"></div>'
  }
}




// WEBPACK FOOTER //
// ./modules/xray/directives/jf_separator/jf_separator.js